export default "__VITE_ASSET__BXEkn5$8__"